module.exports = __webpack_public_path__ + "static/media/bp-left.936a5eee.webp";